import { useContext, useEffect, useRef } from "react";
import { Context } from "../../../context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BaseButton } from "../../button/styled";
import { Row } from "../../flex/styled";
import { H2, Span } from "../../typography/styled";
import { TopNavigationWrapper } from "./styled";
import {
  faArrowUpFromBracket,
  faBars,
  faPlus,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

export const TopNavigation = ({
  title,
  location,
  callToAction,
  handleCallToActionClick,
  bulkCallToAction,
  handleBulkCallToActionClick,
}) => {
  const { setIsSideNavigationOpen } = useContext(Context);
  const actionMenuRef = useRef(null);
  const callToActionIcon = callToAction
    ? callToAction.toString().toLowerCase().includes("download")
      ? faDownload
      : faPlus
    : faPlus;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target)
      ) {
        // Handle click outside if needed
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <TopNavigationWrapper location={location}>
      <H2>{title}</H2>
      <Row className="call-to-action-buttons">
        <BaseButton
          className="add-employee-button"
          onClick={handleCallToActionClick}
        >
          <FontAwesomeIcon icon={callToActionIcon} color="#FFFFFF" />
          <Span>{callToAction ?? "Add Employee"}</Span>
        </BaseButton>
        {handleBulkCallToActionClick && (
          <BaseButton
            className="bulk-upload-button"
            onClick={handleBulkCallToActionClick}
          >
            <FontAwesomeIcon
              icon={faArrowUpFromBracket}
              color="var(--color-text)"
            />
            <Span>{bulkCallToAction ?? "Bulk Upload"}</Span>
          </BaseButton>
        )}
        <BaseButton
          className="hamburger"
          onClick={() => setIsSideNavigationOpen(true)}
        >
          <FontAwesomeIcon icon={faBars} color="#FFFFFF" />
        </BaseButton>
      </Row>
    </TopNavigationWrapper>
  );
};
